var styles = {"progress-bar":"styles_progress-bar__1jIDF","progressBar":"styles_progress-bar__1jIDF","progress-fill":"styles_progress-fill__TAIgA","progressFill":"styles_progress-fill__TAIgA"};

export default styles;
//# sourceMappingURL=styles.css.js.map
